import { render, staticRenderFns } from "./dialogModuleInfo.vue?vue&type=template&id=d7228966&"
import script from "./dialogModuleInfo.vue?vue&type=script&lang=js&"
export * from "./dialogModuleInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogModuleInfo.vue?vue&type=style&index=0&id=d7228966&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports